import {ApplicationRef, assertPlatform, Component, Directive, Input, TemplateRef, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {OrderDayModel, OrderWeekModel} from "../model/dto.model";
import {DateUtilsBs} from "../base/utils/dateUtilsBs";
import {RestClient} from "../rest-client.service";
import {from, groupBy, mergeMap, Observable, of, Subscription, switchMap, tap, toArray, zip} from "rxjs";
import {MpMenuXBVO} from "../model/xbvo.model";
import {OrdersState} from "./orders.state";
import {Router} from "@angular/router";
import {StringUtils} from "../base/utils/string.utils";
import { BsaOrderPlaceholderXBVO } from '../model/dto.models.imported';

/**
 * App-Component
 */
@Component({
    selector: '<skitbs-order-details>',
    templateUrl: './order-details.component.html'
})
export class OrderDetailsComponent extends BaseComponent {

    modelPlaceholderXBVO: BsaOrderPlaceholderXBVO;
    modelMenuXBVO: MpMenuXBVO = new MpMenuXBVO();
    modelMenuName1: string;
    modelMenuName2: string;
    private subscription: Subscription;


    /**
     * Constructor.
     * @param orderDetailsState
     */
    constructor(private orderDetailsState: OrdersState, public router: Router, private restClient: RestClient) {
        super();
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        this.modelPlaceholderXBVO = this.orderDetailsState.selectedPlaceholder.getValue();
        let pNameSplit = StringUtils.splitMenuName(this.modelPlaceholderXBVO.menuName);
        this.modelMenuName1 = pNameSplit[0];
        this.modelMenuName2 = pNameSplit[1];

        // load details
        this.loadMenuDetails();
    }

    /**
     * REST - calls
     * @private
     */
    private loadMenuDetails() {
        this.restClient
            .menuDetails(this.modelPlaceholderXBVO.serviceDay, this.modelPlaceholderXBVO.menuLine)
            .subscribe(aXBVO => this.modelMenuXBVO = aXBVO.menu);
    }

}
